// Module
var code = `<button type="button" ng-click="\$ctrl.onClick()"> <img src="../../../images/logos/google-signin-button-white.svg" alt="Google logo"> <span> <ng-transclude></ng-transclude> </span> </button>`;
// Exports
module.exports = code;